import React from 'react';
import cn from '../../utils/cn';

const sizes = { sm: 'h-4 w-4', md: 'h-6 w-6', lg: 'h-10 w-10' };

const Spinner = ({ size = 'md', className = '' }) => (
  <svg
    className={cn('animate-spin text-primary-600', sizes[size], className)}
    fill="none"
    viewBox="0 0 24 24"
    role="status"
    aria-label="Loading"
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
  </svg>
);

export default Spinner;
